import Box, { BoxProps } from '@mui/material/Box';

export function HiddenOnDesktopBox({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: BoxProps['sx'];
}) {
  return (
    <Box
      sx={{
        display: {
          xs: 'block',
          md: 'none',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export function HiddenOnMobileBox({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: BoxProps['sx'];
}) {
  return (
    <Box
      sx={{
        display: {
          xs: 'none',
          md: 'block',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
